import salesFunnelModule from './modules/sales_funnel'
import visitsModule from './modules/visits'
import Vue from 'vue'
import i18n from '@/languages'
import app from '@/main'

const analyticsModule = {
  namespaced: true,
  state: {
    trafficSourcesList: null,
    trafficSourcesLoading: false
  },
  mutations: {
    setTrafficSourcesList: (state, data) => (state.trafficSourcesList = data),
    setTrafficSourcesLoading: (state, loading) => (state.trafficSourcesLoading = loading)
  },
  actions: {
    GET_TRAFFIC_SOURCES: async ({ rootGetters, commit }) => {
      try {
        commit('setTrafficSourcesLoading', true)
        const response = await Vue.http.get(
          `${rootGetters.getBackendUrl}/analytics/get_traffsources`,
          {
            headers: rootGetters.getAllResponseHeaders
          }
        )

        if (response.status === 200) {
          commit('setTrafficSourcesList', response.body)
          commit('setTrafficSourcesLoading', false)
        } else {
          app.$raven.captureException(new Error('Error - store/analytics, GET_TRAFFIC_SOURCES'), {
            extra: response,
            tags: { component: 'store/analytics', method: 'GET_TRAFFIC_SOURCES' }
          })
        }
      } catch (e) {
        commit('setTrafficSourcesLoading', false)
        app.$message('danger', i18n.t('error_request_data'))
        app.$raven.captureException(new Error('Error - store/analytics, GET_TRAFFIC_SOURCES'), {
          extra: e,
          tags: { component: 'store/analytics', method: 'GET_TRAFFIC_SOURCES' }
        })
      }
    }
  },
  modules: {
    salesFunnel: salesFunnelModule,
    visits: visitsModule
  }
}

export default analyticsModule



// WEBPACK FOOTER //
// ./src/store/modules/analytics/index.js